import './styles/ShoppingCart.scss';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Badge, Grid } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { selectShoppingCart } from 'app/containers/LeihBar/ShoppingCart';
import { ShoppingCartActions } from 'app/containers/LeihBar/ShoppingCart/slice';

export const ShoppingCartButton = () => {
  const dispatch = useDispatch();
  const shoppingCart = useSelector(selectShoppingCart);

  return (
    <Grid item xs="auto" className={'shoppingCart'}>
      <Badge
        className={`shoppingCart__badge${!!shoppingCart.items.length ? '__hasItems' : ''}`}
        badgeContent={shoppingCart.items.length}
        color="primary"
        overlap="circular"
        onClick={() => dispatch(ShoppingCartActions.open())}
      >
        <ShoppingCartIcon sx={{ fontSize: { xs: 24, sm: 32 } }} />
      </Badge>
    </Grid>
  );
};
